import { render } from "./AdminFriendGraphPage.vue?vue&type=template&id=411d7f32&scoped=true"
import script from "./AdminFriendGraphPage.vue?vue&type=script&lang=js"
export * from "./AdminFriendGraphPage.vue?vue&type=script&lang=js"

import "./AdminFriendGraphPage.vue?vue&type=style&index=0&id=411d7f32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-411d7f32"]])

export default __exports__